var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g6321",
    transform: "translate(-9.4000001,96.810998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6323",
    transform: "matrix(1.8215159,0,0,1.8215159,-8.5437653,-109.83667)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path6325",
    fill: "#FFFFFF",
    d: "M64.7503,47.2181c0,4.698-3.8255,8.5235-8.5235,8.5235H9.851V21.9832 c0-4.698,3.8255-8.5235,8.5235-8.5235h46.3758V47.2181L64.7503,47.2181z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6327"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path6338_00000103233165636081272570000003772115506280073390_",
    gradientUnits: "userSpaceOnUse",
    x1: -139.184,
    y1: 132.1548,
    x2: -125.7798,
    y2: 132.1548,
    gradientTransform: "matrix(2.0492 0 0 -2.0492 331.874 307.7619)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#007940"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    style: {
      stopColor: "#00873F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    style: {
      stopColor: "#40A737"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5CB531"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path6338",
    fill: "url(#path6338_00000103233165636081272570000003772115506280073390_)",
    d: "M49.6497,38.5604h3.5235 c0.1007,0,0.3356-0.0336,0.4362-0.0336c0.6711-0.1342,1.2416-0.7383,1.2416-1.5772c0-0.8054-0.5705-1.4094-1.2416-1.5772 c-0.1007-0.0336-0.302-0.0336-0.4362-0.0336h-3.5235V38.5604L49.6497,38.5604z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path6349_00000042710854451642777610000012373653439147370121_",
    gradientUnits: "userSpaceOnUse",
    x1: -139.1842,
    y1: 133.2929,
    x2: -125.7912,
    y2: 133.2929,
    gradientTransform: "matrix(2.0492 0 0 -2.0492 331.874 307.7619)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#007940"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    style: {
      stopColor: "#00873F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    style: {
      stopColor: "#40A737"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5CB531"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path6349",
    fill: "url(#path6349_00000042710854451642777610000012373653439147370121_)",
    d: "M52.7705,16.3121 c-3.3557,0-6.1074,2.7181-6.1074,6.1074v6.3423h8.6242c0.2013,0,0.4362,0,0.604,0.0336 c1.9463,0.1007,3.3893,1.1074,3.3893,2.8523c0,1.3758-0.9732,2.5503-2.7852,2.7852V34.5 c1.9799,0.1342,3.4899,1.2416,3.4899,2.953c0,1.8456-1.6779,3.0537-3.8926,3.0537h-9.4631v12.4161h8.9597 c3.3557,0,6.1074-2.7181,6.1074-6.1074V16.3121H52.7705L52.7705,16.3121z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path6360_00000124840811896044738900000017247869251214553734_",
    gradientUnits: "userSpaceOnUse",
    x1: -139.1841,
    y1: 134.5456,
    x2: -125.7795,
    y2: 134.5456,
    gradientTransform: "matrix(2.0492 0 0 -2.0492 331.874 307.7619)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#007940"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    style: {
      stopColor: "#00873F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    style: {
      stopColor: "#40A737"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5CB531"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path6360",
    fill: "url(#path6360_00000124840811896044738900000017247869251214553734_)",
    d: "M54.4148,32.0503 c0-0.8054-0.5705-1.3423-1.2416-1.443c-0.0671,0-0.2349-0.0336-0.3356-0.0336h-3.1879v2.953h3.1879 c0.1007,0,0.302,0,0.3356-0.0336C53.8443,33.3926,54.4148,32.8557,54.4148,32.0503z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path6371_00000070840166253100884780000015089081306459318918_",
    gradientUnits: "userSpaceOnUse",
    x1: -155.6586,
    y1: 133.3011,
    x2: -142.0469,
    y2: 133.3011,
    gradientTransform: "matrix(2.0492 0 0 -2.0492 331.874 307.7619)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1F286F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    style: {
      stopColor: "#004E94"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    style: {
      stopColor: "#0066B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006FBC"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path6371",
    fill: "url(#path6371_00000070840166253100884780000015089081306459318918_)",
    d: "M19.0121,16.3121 c-3.3557,0-6.1074,2.7181-6.1074,6.1074v15.0671c1.7114,0.8389,3.4899,1.3758,5.2685,1.3758c2.1141,0,3.255-1.2752,3.255-3.0201 v-7.1141h5.2349v7.0805c0,2.7517-1.7114,5-7.5168,5c-3.5235,0-6.2752-0.7718-6.2752-0.7718v12.8523h8.9597 c3.3557,0,6.1074-2.7181,6.1074-6.1074V16.3121C27.9383,16.3121,19.0121,16.3121,19.0121,16.3121z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path6384_00000006709204036799241000000016845649424140387773_",
    gradientUnits: "userSpaceOnUse",
    x1: -147.4605,
    y1: 133.2847,
    x2: -134.2404,
    y2: 133.2847,
    gradientTransform: "matrix(2.0492 0 0 -2.0492 331.874 307.7619)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6C2C2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    style: {
      stopColor: "#882730"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    style: {
      stopColor: "#BE1833"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    style: {
      stopColor: "#DC0436"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E60039"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path6384",
    fill: "url(#path6384_00000006709204036799241000000016845649424140387773_)",
    d: "M35.8913,16.3121 c-3.3557,0-6.1074,2.7181-6.1074,6.1074v7.9866c1.5436-1.3087,4.2282-2.1477,8.557-1.9463 c2.3154,0.1007,4.7987,0.7383,4.7987,0.7383v2.5839c-1.2416-0.6376-2.7181-1.2081-4.6309-1.3423 c-3.2886-0.2349-5.2685,1.3758-5.2685,4.1946c0,2.8523,1.9799,4.4631,5.2685,4.1946c1.9128-0.1342,3.3893-0.7383,4.6309-1.3423 v2.5839c0,0-2.4497,0.6376-4.7987,0.7383c-4.3289,0.2013-7.0134-0.6376-8.557-1.9463v14.094h8.9597 c3.3557,0,6.1074-2.7181,6.1074-6.1074V16.3121C44.851,16.3121,35.8913,16.3121,35.8913,16.3121z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.6e1208cb.svg";
export { ForwardRef as ReactComponent };